import {useEffect} from 'react';
import {useInstance} from 'react-ioc';
import {useQuery} from '@apollo/client';
import {observer} from 'mobx-react-lite';

import {Store} from '../../model/store/Store';
import {onlyCashMe, onlyCashMeVariables} from '../../shared/graphql/__generated__/onlyCashMe';
import {QUERY_ME} from '../../shared/graphql/auth';

export const Me = observer(() => {

    const {auth} = useInstance(Store)
    const query = useQuery<onlyCashMe,onlyCashMeVariables>(QUERY_ME, {
        variables: {token: auth.token!},
        pollInterval: 10000,
    })
    
    useEffect(() => {
        auth.setData(query.data?.onlyCashMe?.FIO!, auth.phone, null, query.data?.onlyCashMe?.paid!)
    }, [auth, query.data?.onlyCashMe?.FIO, query.data?.onlyCashMe?.paid])

    return null

})